import { render, staticRenderFns } from "./DealerInfo.vue?vue&type=template&id=6454b070&scoped=true&"
import script from "./DealerInfo.vue?vue&type=script&lang=js&"
export * from "./DealerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454b070",
  null
  
)

export default component.exports